(function () {
	'use strict';
	$(document).ready(function () {

		if ($('.homepage').length) {

			const swiperNumbers = new Swiper('.swiper-numbers', {
				slidesPerView: 2,
				spaceBetween: 16,
				navigation: {
					prevEl: '.numbers .swiper-navigation .swiper-navigation-prev',
					nextEl: '.numbers .swiper-navigation .swiper-navigation-next'
				},
				breakpoints: {
					1200: {
						slidesPerView: 4,
					},
					768: {
						slidesPerView: 3,
					},
				}
			});

			const swiperQuotation = new Swiper('.swiper-quotation', {
				navigation: {
					prevEl: '.quotation .swiper-navigation .swiper-navigation-prev',
					nextEl: '.quotation .swiper-navigation .swiper-navigation-next'
				},
				autoHeight: true,
			});

		}

	});
}(jQuery));
